"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
exports.IssueListFactory = void 0;
var issue_list_1 = require("../../issue-list/issue-list");
var IssueListFactory = /** @class */ (function () {
    function IssueListFactory() {
    }
    IssueListFactory.prototype.generateIssueList = function (type) {
        switch (type) {
            case issue_list_1.IssueListEnum.DEFAULT:
                this.issueList = new DefaultList();
                break;
            case issue_list_1.IssueListEnum.DFV:
                this.issueList = new DFVList();
                break;
            case issue_list_1.IssueListEnum.SWOT:
                this.issueList = new SWOTList();
                break;
            case issue_list_1.IssueListEnum.ABILITY_TO_LAUNCH:
                this.issueList = new AbilityToLaunchList();
                break;
            // case IssueListEnum.ST_UNCERT:
            //     this.issueList = new StUncertList();
            //     break;
            default:
                this.issueList = new issue_list_1.IssueList();
        }
        return this.issueList;
    };
    return IssueListFactory;
}());
exports.IssueListFactory = IssueListFactory;
var DefaultList = /** @class */ (function (_super) {
    __extends(DefaultList, _super);
    function DefaultList() {
        var _this = _super.call(this) || this;
        _this.VALUES = [];
        return _this;
    }
    DefaultList.prototype.getValues = function () {
        _super.prototype.getValues.call(this);
        console.log('Default');
    };
    return DefaultList;
}(issue_list_1.IssueList));
var DFVList = /** @class */ (function (_super) {
    __extends(DFVList, _super);
    function DFVList() {
        var _this = _super.call(this) || this;
        _this.DESIRABILITY = _this.FEASIBILITY = _this.VIABILITY = [];
        return _this;
    }
    DFVList.prototype.getValues = function () {
        _super.prototype.getValues.call(this);
        console.log('DFVList');
    };
    return DFVList;
}(issue_list_1.IssueList));
var SWOTList = /** @class */ (function (_super) {
    __extends(SWOTList, _super);
    function SWOTList() {
        var _this = _super.call(this) || this;
        _this.STRENGTHS = _this.WEAKNESSES = _this.OPPORTUNITIES = _this.THREATS = [];
        return _this;
    }
    SWOTList.prototype.getValues = function () {
        _super.prototype.getValues.call(this);
        console.log('SWOTList');
    };
    return SWOTList;
}(issue_list_1.IssueList));
var AbilityToLaunchList = /** @class */ (function (_super) {
    __extends(AbilityToLaunchList, _super);
    function AbilityToLaunchList() {
        var _this = _super.call(this) || this;
        _this.dfvList = new DFVList();
        _this.swotList = new SWOTList();
        return _this;
    }
    AbilityToLaunchList.prototype.getValues = function () {
        _super.prototype.getValues.call(this);
        console.log('AbilityToLaunchList');
    };
    return AbilityToLaunchList;
}(issue_list_1.IssueList));
// class StUncertList extends IssueList{
//     constructor(){
//       super();
//       this.STRENGTHS = this.WEAKNESSES = this.OPPORTUNITIES = this.THREATS = [];
//     }
//
//     getValues(){
//         super.getValues();
//         console.log('StUncertList');
//     }
// }
//# sourceMappingURL=issue-list-factory.js.map


// WEBPACK FOOTER //
// ./app/components/utils/issue-list/issue-list-factory/issue-list-factory.js